import { makeStyles } from "@material-ui/core";

export const CustomTooltipStyle = makeStyles((theme) => ({
  container: {
    position: "absolute",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginLeft: 352,
    height: "8%",
    zIndex: 500,
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      marginTop: 60,
      marginLeft: 200,
    },
    [theme.breakpoints.down(420)]: {
      marginLeft: 160,
    },
  },
  triangle: {
    width: 0,
    height: 0,
    marginRight: -1,
    borderStyle: "solid",
    borderWidth: "15px 20px 15px 0",
    borderColor: "transparent #d9e7f0 transparent transparent",
    [theme.breakpoints.down("xs")]: {
      transform: "rotate(90deg)",
    },
  },
  tooltip: {
    width: "164px",
    background: "#d9e7f0",
    borderRadius: "8px",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      marginTop: -8,
    },
  },
  content: {
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(12),
    color: "#235693",
    margin: "10px",
  },
}));
